import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../utils/axiosConfig';
import PageLoadingArea from '../../components/PageLoader/PageLoadingArea';
import usePageLoading from '../../hooks/usePageLoading';
import '../../styles/FormPage.css';

function CreateCompany() {
    const { companyId } = useParams();
    const navigate = useNavigate();
    const { isLoading, withLoading } = usePageLoading(Boolean(companyId));
    const [formData, setFormData] = useState({
        name: '',
        gstNo: ''
    });

    useEffect(() => {
        if (companyId) {
            withLoading(async () => {
                const res = await api.get(`/companies/${companyId}`);
                setFormData({
                    name: res.data.name || '',
                    gstNo: res.data.gstNo || ''
                });
            }).catch(() => {
                alert('Error fetching company data');
            });
        }
    }, [companyId, withLoading]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            name: formData.name.trim(),
            gstNo: formData.gstNo.trim() || null
        };

        const apiCall = companyId
            ? api.put(`/companies/${companyId}`, payload)
            : api.post('/companies', payload);

        apiCall
            .then(() => {
                navigate('/admin/companies');
            })
            .catch((error) => {
                const message = error.response?.data?.Error || 'Error saving company details';
                alert(message);
            });
    };

    return (
        <PageLoadingArea isLoading={isLoading}>
            <div className="form-page">
                <div className="form-page-header">
                    <div>
                        <h1>{companyId ? 'Edit company' : 'Add company'}</h1>
                        <p className="form-page-subtitle">
                            {companyId
                                ? 'Update company name and GST details'
                                : 'Enter company details to add them to your records'}
                        </p>
                    </div>
                    <div className="form-page-actions">
                        <button
                            type="button"
                            className="form-page-btn-secondary"
                            onClick={() => navigate('/admin/companies')}
                        >
                            Back to list
                        </button>
                        <button
                            type="submit"
                            form="create-company-form"
                            className="form-page-btn"
                        >
                            {companyId ? 'Update company' : 'Save company'}
                        </button>
                    </div>
                </div>

                <section className="form-page-section">
                    <div className="form-page-section-head">
                        <div>
                            <h2>Company details</h2>
                            <p className="form-page-section-hint">Company name and optional GST number</p>
                        </div>
                    </div>

                    <form id="create-company-form" onSubmit={handleSubmit}>
                        <div className="form-page-grid cols-3">
                            <div className="form-page-field span-full">
                                <label htmlFor="name">Company name</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    placeholder="Enter company name"
                                />
                            </div>
                            <div className="form-page-field">
                                <label htmlFor="gstNo">GST No (optional)</label>
                                <input
                                    type="text"
                                    id="gstNo"
                                    name="gstNo"
                                    value={formData.gstNo}
                                    onChange={handleChange}
                                    placeholder="Enter GST number"
                                />
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </PageLoadingArea>
    );
}

export default CreateCompany;
